import { Route, Routes } from "react-router-dom"
import { AcquisitionFormPageWrapper } from "./AcquisitionFormPageWrapper"
import { AcquisitionThankYou } from "../acquisitionForm/thankYou/AcquisitionThankYou"
import { WEB_LINKS } from "../links"
import { AcquisitionFormStepProps, getCompleteAcquisitionFormSteps } from "./acquisitionForm.config"
import { AcqusitionProgressProvider } from "./AcquisitionProgressContext"

type Props = {
  formVariant?: AcquisitionFormStepProps["formVariant"]
}

export function AcquisitionFormRouter(props: Props) {
  const acquisitionFormSteps = getCompleteAcquisitionFormSteps()
  return (
    <Routes>
      <Route path="" element={<AcqusitionProgressProvider />}>
        <Route path="" element={<AcquisitionFormPageWrapper />}>
          {acquisitionFormSteps.map((step) => (
            <Route
              key={step.routePath}
              path={step.routePath}
              element={<step.PageComponent formVariant={props.formVariant} />}
            />
          ))}
        </Route>
      </Route>

      <Route path={WEB_LINKS.acquisitionThankYou} element={<AcquisitionThankYou />} />
    </Routes>
  )
}
